export default __webpack_public_path__ + "91285b93e3f3d51248477ea77293f0f7.svg";